import {Card} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import {OverdueDocumentListLoad} from '../../Documents/OverdueDocumentsList/OverdueDocumentList';


const useStyles = makeStyles(() => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 800
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const OverdueDocuments = (props: { className?: string }) => {
  const {className, ...rest} = props;
  const classes = useStyles();

  return (
      <Card
          {...rest}
          className={clsx(classes.root, className)}
      >
        <OverdueDocumentListLoad/>
      </Card>
  );
};

export default OverdueDocuments;
